"use client";
import React, { ReactNode } from "react";
import { useData } from "./context";
import { useQuery } from "@tanstack/react-query";
import { commonAction } from "@libs/actions/actions";

interface props {
  children: ReactNode;
}
const ConfigProvider = ({ children }: props) => {
  const { setConfigData } = useData();

  const { data: configData } = useQuery({
    queryKey: ["configData"],
    queryFn: async () => {
      try {
        const response = await commonAction({
          endPoint: "/configuration",
          type: "get",
        });
        return response ?? null;
      } catch (error) {
        // Log for diagnostics; return null so consumers can handle absence
        // eslint-disable-next-line no-console
        console.error("ConfigProvider: failed to fetch configuration", error);
        return null;
      }
    },
    retry: 1,
    enabled: typeof window !== "undefined" ? navigator.onLine : false,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (configData != null) {
      try {
        setConfigData(configData);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("ConfigProvider: setConfigData failed", err);
      }
    }
  }, [configData, setConfigData]);

  return <div>{children}</div>;
};

export default ConfigProvider;
